import { getIsQuietHoursOverlappingWithSTO } from 'modules/campaigns/lib/utils';
import { useWatch } from 'react-hook-form';

export const useQuietHoursAndStoOverlap = (): boolean => {
  const [useQuietHours, customQuietHours, useSendTimeOptimization, stoCompletionTime] = useWatch({
    name: ['useQuietHours', 'customQuietHours', 'useSendTimeOptimization', 'stoCompletionTime'],
  });

  if (!useQuietHours || !useSendTimeOptimization) return false;

  return getIsQuietHoursOverlappingWithSTO(customQuietHours, Number(stoCompletionTime));
};
